import { Button, ButtonGroup, Card, CardBody, Col } from "reactstrap";
import { ButtonHeading, VerticalTitle } from "../../../constants";
import CommonDropdown from "../common/CommonDropdown";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { VerticalText } from "../../../data/buttons/GroupButton";

const VerticalButtonGroup = () => {
  return (
    <Col lg="6">
      <Card className="vertical-btn-group">
        <CommonCardHeader headClass="card-no-border pb-0" title={VerticalTitle} span={VerticalText} tag />
        <CardBody className="btn-group-wrapper">
          <ButtonGroup vertical>
            <Button color="primary">{ButtonHeading}</Button>
            <Button color="secondary">{ButtonHeading}</Button>
            <ButtonGroup>
              <CommonDropdown color="success" />
            </ButtonGroup>
            <Button color="info">{ButtonHeading}</Button>
            <Button color="warning">{ButtonHeading}</Button>
            <CommonDropdown color="danger" />
            <CommonDropdown color="light" />
          </ButtonGroup>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VerticalButtonGroup;
